require('babel-polyfill')
import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import ReduxThunk from "redux-thunk";
import { History } from "history";
import { routerReducer, routerMiddleware } from "react-router-redux";
import createDebounce from "redux-debounced";

import currentUserReducer from "./current_user";
import requestAccessReducer from "./request_access";
import templatesReducer from "./templates";
import userTokensReducer from "./user_tokens";
import veeWalletReducer from "./vee_wallet";
import docPageReducer from "./doc_page";
import labReducer from "./lab";
import labHttpReducer from "./lab_http";
import profilePageReducer from "./profile_page";

const composeEnhancers =
	typeof window === "undefined" ? compose : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const createReduxStore = (history: History) =>
	createStore(
		combineReducers({
			router: routerReducer,
			currentUser: currentUserReducer,
			userTokens: userTokensReducer,
			requestAccess: requestAccessReducer,
			templates: templatesReducer,
			veeWallet: veeWalletReducer,
			lab: labReducer,
			labHttp: labHttpReducer,
			docPage: docPageReducer,
			profilePage: profilePageReducer,
		}),
		composeEnhancers(
			applyMiddleware(ReduxThunk),
			applyMiddleware(routerMiddleware(history)),
			applyMiddleware(createDebounce({ simple: 300 }))
		)
	);

export default createReduxStore;



// WEBPACK FOOTER //
// ./src/reducers/index.ts